// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nt-9";
export var arrowButtonContainer = "_nt-5";
export var arrowButtonIcon = "_nt-6";
export var carouselArrowButton = "_nt-2";
export var carouselElementContainer = "_nt-1";
export var currentSlide = "_nt-8";
export var left = "_nt-3";
export var otherSlide = "_nt-a";
export var productCarouselContainer = "_nt-0";
export var right = "_nt-4";
export var sliderOverflow = "_nt-7";